<div class="py-10">
	<!-- Loading -->
	<div *ngIf="loading" class="flex justify-center items-center py-8">
		<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
		<span class="ml-2 text-gray-600">Chargement des activités...</span>
	</div>

	<!-- Tableau des activités -->
	<div *ngIf="!loading" class="bg-white rounded-lg border border-gray-200 shadow overflow-hidden">
		<div class="overflow-x-auto">
			<table class="w-full">
				<thead>
					<tr class="bg-gray-50 border-b border-gray-200">
						<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Date</th>
						<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Contenu de l'activité</th>
						<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">IP</th>
						<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Type</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let activity of paginatedActivities" class="border-b border-gray-100 hover:bg-gray-50">
						<td class="py-3 px-4 text-sm text-gray-900">
							{{ formatDate(activity.createdAt) }}
						</td>
						<td class="py-3 px-4 text-sm text-gray-600">
							{{ activity.metadata.description }}
						</td>
						<td class="py-3 px-4 text-sm text-gray-500">
							{{ activity.actorIp }}
						</td>
						<td class="py-3 px-4">
							<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium">
								{{ getStatusText(activity.action) }}
							</span>
						</td>
					</tr>

					<!-- Message si aucune activité -->
					<tr *ngIf="paginatedActivities.length === 0">
						<td colspan="5" class="py-8 px-4 text-center text-gray-500">
							<svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
									d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
							</svg>
							<p class="mt-2">Aucune activité trouvée</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- Pagination -->
		<div *ngIf="totalPages > 1" class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
			<div class="flex items-center justify-between">
				<div class="flex-1 flex justify-between sm:hidden">
					<button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
						class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
						Précédent
					</button>
					<button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
						class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
						Suivant
					</button>
				</div>
				<div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
					<div>
						<p class="text-sm text-gray-700">
							Page <span class="font-medium">{{ currentPage }}</span> sur
							<span class="font-medium">{{ totalPages }}</span>
							({{ pagination?.total || 0 }} activités au total)
						</p>
					</div>
					<div>
						<nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
							<!-- Bouton Précédent -->
							<button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
								class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
								<span class="sr-only">Précédent</span>
								<svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
									<path fill-rule="evenodd"
										d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
										clip-rule="evenodd" />
								</svg>
							</button>

							<!-- Pages -->
							<button *ngFor="let page of pagesArray" (click)="changePage(page)"
								[class]="page === currentPage 
                ? 'relative inline-flex items-center px-4 py-2 border text-sm font-medium bg-blue-50 border-blue-500 text-blue-600' 
                : 'relative inline-flex items-center px-4 py-2 border text-sm font-medium bg-white border-gray-300 text-gray-500 hover:bg-gray-50'">
								{{ page }}
							</button>

							<!-- Bouton Suivant -->
							<button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
								class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
								<span class="sr-only">Suivant</span>
								<svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
									<path fill-rule="evenodd"
										d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
										clip-rule="evenodd" />
								</svg>
							</button>
						</nav>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>